<template>
  <q-card style="min-width: 350px">
    <q-card-section>
      <div class="text-h6">
        {{ isEditing ? 'Guncelle' : 'Yeni Danisan' }}
      </div>
    </q-card-section>

    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Customer Name -->
        <q-input
          v-model="name"
          filled
          label="Isim ve Soyisim"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Customer Gender -->
        <q-select
          v-model="gender"
          filled
          :options="genderOpt"
          label="Cinsiyet"
        />

        <!-- Customer Email -->
        <q-input
          v-model="email"
          filled
          label="E Posta Adresi"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Customer Phone -->
        <q-input
          v-model="phone"
          filled
          label="Telefon Numarasi"
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Customer Birthday -->
        <q-input
          v-model="birthday"
          filled
          label="Dogum Tarihi"
          :rules="['date']"
        >
          <template #append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                ref="qDateProxy"
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date v-model="birthday" mask="DD-MM-YYYY">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Kapat" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>

        <!-- Customer Medical Tags -->
        <q-input
          v-model="medicalSwap"
          filled
          label="Medikal Uyarilar"
          @keyup.enter="addMedicalTag"
        >
          <template #prepend>
            <q-chip
              v-for="(tag, index) in medical"
              :key="index"
              removable
              @remove="deleteMedicalTag(index)"
            >
              {{ tag }}
            </q-chip>
          </template>
        </q-input>
      </q-form>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn v-close-popup flat label="Vazgec" color="red" />
      <q-btn
        v-close-popup
        flat
        :label="isEditing ? 'Guncelle' : 'Ekle'"
        color="secondary"
        @click="onSubmit"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import * as eventNames from '../../utils/events'
import * as mappers from '../../utils/mapper'
import * as notify from '../../utils/notification'
import * as timetravel from '../../utils/timetravel'

export default {
  props: {
    isEditing: Boolean,
    customer: Object,
  },
  setup(props) {
    const $q = useQuasar()
    const emitter = inject('emitter')
    let { isEditing, customer } = toRefs(props)

    // subscription form inputs
    const name = ref(null)
    const gender = ref(null)
    const email = ref(null)
    const phone = ref(null)
    const birthday = ref(null)
    const medicalSwap = ref(null)
    let medical = []

    if (isEditing.value) {
      name.value = customer.value.name
      gender.value = mappers.getGenderOption(customer.value.gender)
      email.value = customer.value.email
      phone.value = customer.value.phone
      birthday.value = timetravel.fromYearMonthDayToReverse(
        customer.value.birthday
      )
      medical = customer.value.medical
    }

    // todo: check if birthday still works with new mask
    function prepareRequestPayload() {
      return {
        name: name.value,
        gender: gender.value.value,
        email: email.value,
        phone: phone.value,
        birthday: timetravel.fromDayMonthYearToReverse(birthday.value),
        medical: medical,
      }
    }

    return {
      name,
      gender,
      email,
      phone,
      birthday,
      medical,
      medicalSwap,
      genderOpt: mappers.genderOptions(),
      prepareRequestPayload,
      addMedicalTag() {
        medical.push(medicalSwap.value)
        medicalSwap.value = ''
      },
      deleteMedicalTag(index) {
        medical.splice(index, 1)
      },
      onSubmit() {
        if (isEditing.value) {
          axios
            .post(`/customers/${customer.value.id}`, prepareRequestPayload())
            .then(() => {
              $q.notify(notify.success('Danisan guncellendi.'))
              emitter.emit(eventNames.REFRESH_CUSTOMERS)
            })
            .catch(() => {
              $q.notify(notify.warning('Danisan guncellenemedi.'))
            })
        } else {
          axios
            .post('/customers/', prepareRequestPayload())
            .then(() => {
              $q.notify(notify.success('Danisan eklendi.'))
              emitter.emit(eventNames.REFRESH_CUSTOMERS)
            })
            .catch(() => {
              $q.notify(notify.warning('Danisan eklenemedi.'))
            })
        }
      },
    }
  },
}
</script>
